import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=2c5d39d0&"
import script from "./FavoriteButton.vue?vue&type=script&lang=js&"
export * from "./FavoriteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1693793820/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5d39d0')) {
      api.createRecord('2c5d39d0', component.options)
    } else {
      api.reload('2c5d39d0', component.options)
    }
    module.hot.accept("./FavoriteButton.vue?vue&type=template&id=2c5d39d0&", function () {
      api.rerender('2c5d39d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/FavoriteButton.vue"
export default component.exports